// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, getColorTint, unit, unitTRBL, white } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import UnorderedList, {
  UnorderedListProps,
} from '@zego/components/molecules/UnorderedList';
import ContentContainer from '@zego/components/SCContentContainer';

interface WhatsIncludedProps {
  data: UnorderedListProps[];
}

export default function WhatsIncluded({
  data,
}: WhatsIncludedProps): JSX.Element {
  return (
    <Container>
      <CentredHeading>What's included?</CentredHeading>
      <Spacer height={unit(6)} />
      <InnerContainer>
        {data.map((element, index) => (
          <View key={index}>
            <UnorderedList {...element} />
          </View>
        ))}
      </InnerContainer>
    </Container>
  );
}

const Container = styled(View)({
  backgroundColor: getColorTint('grey', 2),
  color: white,
  padding: unitTRBL(8, 0, 8, 0),
});

const InnerContainer = styled(ContentContainer)(`
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  ${BREAKPOINTS.medium} {
    grid-template-columns: repeat(2, 1fr);
    
    & div {
      margin-right: ${unit(2)}px;
    }

    & div:last-child {
      margin-left: ${unit(2)}px;
    }
  },
`);

const CentredHeading = styled(H2)({
  textAlign: 'center',
});
